import React from "react";
import _ from "lodash";
import isSelectingText from "Utils/isSelectingText";
import DropdownMenu from "Components/dropdownMenu/DropdownMenu";
import DetailInfo from "Components/detailInfo/DetailInfo";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import t from "Utils/translation";
import { Icon, user, trash, enable, disable, more } from "Icons/index";

import cx from "classnames";
import s from "./delegateCard.scss";

export default class DelegateCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
    };
  }

  onDropdownOpenChange = (newVal) => {
    this.setState({ isMenuOpen: newVal });
  };

  destroy = () => {
    this.props.delete(this.props.code);
  };

  render() {
    const {
      status,
      company,
      code,
      showDelegate,
      firstname,
      lastname,
      email_accounts,
      is_customer_disabled,
      canEnableDelegate,
      canManageDelegate,
    } = this.props;

    return (
      <div
        className={s.card}
        onClick={() => {
          if (!isSelectingText()) {
            showDelegate(code);
          }
        }}
      >
        <div className={cx(s.statusCircle, { [s[status]]: true })}>
          <Icon className={s.iconUser} svg={user} width="0.75rem" height="0.75rem" />
        </div>

        <div className={s.name}>{`${firstname} ${lastname}`}</div>

        <div className={s.info}>
          <DetailInfo className={s.detailInfo} label={t("detailInfo.label.code")} info={code} inLine />
          {company && (
            <DetailInfo className={s.detailInfo} label={t("detailInfo.label.company")} info={company} inLine />
          )}
        </div>

        <DropdownMenu
          isOpen={this.state.isMenuOpen}
          onOpenChange={this.onDropdownOpenChange}
          hideToggle={!canEnableDelegate && !canManageDelegate}
          actions={[
            {
              isHidden: !canEnableDelegate || status !== "enabled",
              onClick: () => this.props.changeDelegateStatus(code, "disabled", is_customer_disabled),
              icon: disable,
              label: t("ddMenu.disable"),
            },
            {
              isHidden: !canEnableDelegate || status !== "disabled",
              onClick: () => this.props.changeDelegateStatus(code, "enabled", is_customer_disabled),
              icon: enable,
              label: t("ddMenu.enable"),
            },
            {
              isHidden: !canManageDelegate,
              onClick: this.destroy,
              icon: trash,
              label: t("ddMenu.delete"),
            },
          ]}
        >
          <div className={cx(s.ddMenu)}>
            <ButtonIcon icon={more} />
          </div>
        </DropdownMenu>
      </div>
    );
  }
}
